import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent implements OnInit {

  prodFormGroup;
  submitted = false;
  fileToUpload: any;

  reward_details={
    reward_products:[],
    product_types: [],
    reward_categories:[],
    reward_sub_categories:[],
    reward_product_points:[],
    reward_brands:[],
    price_type:[]
  };

  price_slab=[
    {
        "denominations":0,
        "mrp":0,
        "points":0
    },
  ];

  reward_detailsSelected:any = {price_type:''};
  constructor(private router :Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private toast: ToastClientService,
    private route: ActivatedRoute,

    ) { }

  ngOnInit() {


    this.route.params
      .subscribe(
        (params: Params) => {
          let prodId = +params['prodId'];
          console.log( prodId);
          this.getRewardbyId(prodId)
        }
      );

    this.prodFormGroup = this.fb.group({
      program_id: 1,
      prod_name: new FormControl('', [Validators.required]),
      product_type: new FormControl('', [Validators.required]),
      reward_category_id: new FormControl('', [Validators.required]),
      reward_sub_categoryid: new FormControl('', [Validators.required]),
      sku: new FormControl(''),
      description: new FormControl(''),
      min_custom_price: new FormControl(''),
      max_custom_price: new FormControl(''),
      base_image: new FormControl(''),
      reward_brand_id: new FormControl('', [Validators.required]),
      price_type: new FormControl('', [Validators.required]),

    });

  }


  get f() {
    return this.prodFormGroup.controls
  }

  getRewardbyId(id) {
    this.apiService.get(this.apiConfig.getRewardProductbyId+id).subscribe(
      (res: any) => {
        this.reward_details = res.data;

        console.log("this.reward_details::",this.reward_details)

        if(this.reward_details.reward_product_points.length>0)
        {
          this.price_slab= this.reward_details.reward_product_points;
        }

        this.prodFormGroup.controls['prod_name'].setValue(this.reward_details.reward_products[0].prod_name)
        this.prodFormGroup.controls['product_type'].setValue(this.reward_details.reward_products[0].product_type)
        this.prodFormGroup.controls['sku'].setValue(this.reward_details.reward_products[0].sku)
        this.prodFormGroup.controls['description'].setValue(this.reward_details.reward_products[0].description)

        this.prodFormGroup.controls['reward_category_id'].setValue(this.reward_details.reward_products[0].reward_category_id)
        this.prodFormGroup.controls['reward_sub_categoryid'].setValue(this.reward_details.reward_products[0].reward_sub_categoryid)
        this.prodFormGroup.controls['reward_brand_id'].setValue(this.reward_details.reward_products[0].reward_brand_id)

        this.prodFormGroup.controls['price_type'].setValue(this.reward_details.reward_products[0].price_type)
        this.prodFormGroup.controls['min_custom_price'].setValue(this.reward_details.reward_products[0].min_custom_price)
        this.prodFormGroup.controls['max_custom_price'].setValue(this.reward_details.reward_products[0].max_custom_price)

        this.fileToUpload = this.reward_details.reward_products[0].mobile;

      },
      (err) => {
        console.log(err);
      }
    );
  }




  imageChange(img) {

    console.log(img)
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function () {
      //self.AddOffer.controls['offer_image'].setValue(reader.result);
      self.prodFormGroup.value.offer_image = reader.result;
      self.fileToUpload = reader.result;
    }
    reader.readAsDataURL(file);

  }


  onEditReward(formData:any) {
    this.submitted = true;

    console.log(formData)
    if (this.prodFormGroup.invalid) {
      return;
    }
    formData.id= this.reward_details.reward_products[0].id;
   formData.base_image = this.fileToUpload;

   formData.price_slab = JSON.stringify(this.price_slab) ;
    console.log(formData)

    this.apiService.post(this.apiConfig.updateRewardProducts, formData)
      .subscribe((res: any) => {
        this.toast.Success('Reward Product Updated successfully')
        this.router.navigateByUrl('/hubAdmin/reward-products')
      }, err => {
        this.toast.Error('Error Updating Reward Product');
      })

     }



     addPriceSlab()
     {
          let obj={
            "denominations":0,
            "mrp":0,
            "points":0
          }
          this.price_slab.push(obj)
          console.log(this.price_slab)
     }

     removePriceSlab(obj)
     {
       if(this.price_slab.length==1)
       {
         this.toast.Error("Cant be Deleted")
         return;
       }
      this.price_slab = this.price_slab.filter(o => o !== obj);
     }

     onChangeEachItem(val,name,index){
      this.price_slab[index][name]= Number(val);
      console.log(this.price_slab);
    }
    rewardCategoryChanged(eve){
      this.getSubCategories(eve);
      this.getRewadBrands(eve);
    }
    getSubCategories(eve){
      console.log(this.apiConfig.getRewardSubCategory+eve);
      this.apiService.get(this.apiConfig.getRewardSubCategory+eve).subscribe(
        (res: any) => {
          console.log(res);
          if(res.data){
            this.reward_details.reward_sub_categories = res.data.reward_sub_categories;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
    getRewadBrands(eve){
      console.log(eve);
      this.apiService.get(this.apiConfig.getRewardsBrands+eve).subscribe(
        (res: any) => {
          console.log(res);
          if(res.data){
            this.reward_details.reward_brands = res.data.reward_brands;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }

}
